import React, { useEffect, useState } from 'react';
import { Button } from '@vtbhome/juicyfront';
import { Toast } from '@shared/ui/toast/toast';
import toast from 'react-hot-toast';
import { getQueryError } from '@shared/lib/utils/get-query-error/get-query-error';
import { CreateFeedbackSubjectProps } from './types';
import { ModalMutateFeedbackSubject } from './modal-mutate-feedback-subject/modal-mutate-feedback-subject';
import { useCreateFeedbackSubjectMutation } from '@entities/feedback-subject/api/feedback-subject-api';
import { CACHE_KEY_FEEDBACK_SUBJECT_CREATE } from '@entities/feedback-subject/config/api-constants';

export const CreateFeedbackSubject: React.FC<CreateFeedbackSubjectProps> = ({ onSuccess, ...props }) => {
    const [, createFeedbackSubjectResult] = useCreateFeedbackSubjectMutation({
        fixedCacheKey: CACHE_KEY_FEEDBACK_SUBJECT_CREATE,
    });

    const [isShowModal, setIsShowModal] = useState(false);

    const handleOpen = () => {
        setIsShowModal(true);
    };

    const handleClose = () => {
        setIsShowModal(false);
    };

    useEffect(() => {
        if (isShowModal && createFeedbackSubjectResult.isSuccess) {
            onSuccess?.();
            toast.custom((t) => {
                return (
                    <Toast
                        type='success'
                        title='Успешно!'
                        description='Тема создана'
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            createFeedbackSubjectResult.reset();
        } else if (isShowModal && createFeedbackSubjectResult.isError) {
            toast.custom((t) => {
                return (
                    <Toast
                        type='error'
                        title='Ошибка!'
                        description={`Не удалось создать тему обращения.\n${getQueryError(createFeedbackSubjectResult)?.message}`}
                        onClose={() => {
                            toast.remove(t.id);
                        }}
                    />
                );
            });
            createFeedbackSubjectResult.reset();
        }
    }, [isShowModal, createFeedbackSubjectResult.isSuccess, createFeedbackSubjectResult.isError]);

    return (
        <>
            <Button {...props} buttonType='primary' onClick={handleOpen}>
                Создать тему
            </Button>
            <ModalMutateFeedbackSubject isShowModal={isShowModal} onAccept={handleClose} onClose={handleClose} />
        </>
    );
};
